import { render, staticRenderFns } from "./PlanForm.vue?vue&type=template&id=235789d7&scoped=true"
import script from "./PlanForm.vue?vue&type=script&lang=js"
export * from "./PlanForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235789d7",
  null
  
)

export default component.exports